/* 
 * This file is created by Vatsaly Patel
 * Note: If you are editing anything, please let me know - or do comment [it's compulsory]
*/

import React, { Component } from "react";
import Label from "../../components/label";
import ICBUtton from "../../components/button";
import { NavLink } from "react-router-dom";
import appRoutes from "../../routes/appRoutes";
import MakeAPICall from "../../apiCalls/common";
import { getBankDetailsDoctor } from "../../apiRoutes";

class BankDetailsPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      apiCall: "",
      noData: false,
      bankDetails: null
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    let apiCallParam = {
      reqType: "GET",
      reqURL: getBankDetailsDoctor,
      dataObj: {},
      params: {},
      headers: {},
      successCallback: res => {
        if(JSON.stringify(res.data.data) === "{}") this.setState({noData: true});
        else{
          this.setState({bankDetails: res.data.data});
        }
      },
      failureCallback: err => {
        console.log("Something went wrong. Please try again ", err);
      },
      showPopUp: false
    };
    this.setState({
      apiCall: apiCallParam
    });
  };

  gotoAddBankDetail = () => {    
    this.props.history.push(appRoutes.addBankDetails);
  }

  render() {
    return (
      <div className="row rounded p-3 bank-details-page">
        <div className="col-sm-3 p-3">
          <Label title="Bank Details" className="big" />
        </div>
        <div className={this.state.noData ? 'col-sm-3 offset-sm-6 text-right pt-3' : 'd-none'}>
          <ICBUtton title="Add Bank Detail" clickEvent={this.gotoAddBankDetail} />
        </div>
        <div className="col-sm-12 border-bottom"></div>

        <div className="col-sm-12 mt-4">
          <div className={!this.state.noData ? 'card custom-card-width' : 'd-none'}>
            <div className="card-body">
              <Label
                className="card-title large secondary-font w-100"
                title={this.state.bankDetails && this.state.bankDetails.manageAccount ? this.state.bankDetails.manageAccount.accountHolderName : '-'}
              />
              <Label className="card-text w-100" title={this.state.bankDetails && this.state.bankDetails.manageAccount.bankAccoutLastFourDigit ? 'XX-XXXX-' + this.state.bankDetails.manageAccount.bankAccoutLastFourDigit.substr((this.state.bankDetails.manageAccount.bankAccoutLastFourDigit.length - 4)) : '-'} />
              {/* <Label className="card-text w-100" title="XX-XXXX-3456" /> */}
              <Label className="card-text w-50" title={this.state.bankDetails &&  this.state.bankDetails.manageAccount ? this.state.bankDetails.manageAccount.bankAccountName : '-'} />
              <NavLink
                to={appRoutes.editBankDetails}
                className="text-decoration-none primary-color float-right"
                href="#"
              >
                <span className="font-15">Edit</span>
              </NavLink>
            </div>
          </div>
          <div className={this.state.noData ? 'card custom-card-width' : 'd-none'}>
            <div className="card-body">
              <Label
                className="card-title large secondary-font w-100"
                title="No Data Found"
              />
            </div>
          </div>
        </div>
        {/* API Call */}
        <MakeAPICall apiParam={this.state.apiCall} />
      </div>
    );
  }
}

export default BankDetailsPage;
